import { ConfiguratorFunction, configuratorFunctions } from '@constants/configurator-function';
import { StringUtils } from './string-utils';

export namespace QueryUtils {

  export function getParameterByName(name: string, url?: string): string | undefined {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) {
      return undefined;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  export function getAllParameters(url?: string): any {
    if (!url) {
      url = window.location.href;
    }
    const params: any = {};
    const index = url.indexOf('?');
    if (index === -1) {
      return params;
    }
    const query = url.substring(index + 1);
    const queryParams = query.split('&');
    for (const param of queryParams) {
      const pair = param.split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  }

  export function hasNoParams(): boolean {
    return Object.keys(QueryUtils.getAllParameters()).length === 0;
  }

  export function hasConfiguratorParams(): boolean {
    return configuratorFunctions.includes(getParameterByName('function')?.toLowerCase() as ConfiguratorFunction);
  }


  export function isAssistantImportLink(url?: string): boolean {
    if (!url) {
      url = window.location.href;
    }
    const functionParamValue: string | undefined = getParameterByName('function', url);
    if (!functionParamValue || functionParamValue.toLowerCase() as ConfiguratorFunction !== "assistantimport") {
      return false;
    }
    const storageIdParamValue: string | undefined = QueryUtils.getParameterByName('storageid');
    return !!storageIdParamValue;
  }

  export function isTemporaryLinkUrl(url?: string): boolean {
    if (!url) {
      url = window.location.href;
    }

    const functionParamValue: string | undefined = QueryUtils.getParameterByName('function', url);
    if (!functionParamValue || functionParamValue.toLowerCase() as ConfiguratorFunction !== "loadproject") {
      return false;
    }

    const temporaryUrlGUIDParamValue: string | undefined = QueryUtils.getParameterByName('guid', url);
    return !StringUtils.isEmpty(temporaryUrlGUIDParamValue);
  }
}
